import create from 'zustand';

const useStore = create((set) => ({
  appData: null,
  setAppData: (value) => set(() => ({ appData: value })),

  contactFormData: null,
  setContactFormData: (value) => set(() => ({ contactFormData: value })),

  isIntro: true,
  setIsIntro: (value) => set(() => ({ isIntro: value })),

  isPcLoaded: null,
  setIsPcLoaded: (value) => set(() => ({ isPcLoaded: value })),

  isShareOpen: false,
  setIsShareOpen: () => set((state) => ({ isShareOpen: !state.isShareOpen })),

  isAboutOpen: false,
  setIsAboutOpen: () => set((state) => ({ isAboutOpen: !state.isAboutOpen })),

  isContactOpen: false,
  setIsContactOpen: (value) => set(() => ({ isContactOpen: value })),

  isWhitePaperOpen: false,

  setIsWhitePaperOpen: (value) => set(() => ({ isWhitePaperOpen: value })),

  animatedBoxStartPosition: null,
  setAnimatedBoxStartPosition: (value) =>
    set(() => ({ animatedBoxStartPosition: value })),

  animatedBoxEndPosition: null,
  setAnimatedBoxEndPosition: (value) =>
    set(() => ({ animatedBoxEndPosition: value })),

  isArticleOpen: false,
  setIsArticleOpen: (value) => set(() => ({ isArticleOpen: value })),

  isGalleryOpen: false,
  setIsGalleryOpen: (value) => set(() => ({ isGalleryOpen: value })),
  clickedGalleryImage: null,
  setClickedGalleryImage: (value) =>
    set(() => ({ clickedGalleryImage: value })),

  isOnboardingOpen: false,
  setIsOnboardingOpen: () =>
    set((state) => ({ isOnboardingOpen: !state.isOnboardingOpen })),

  roomId: -1,
  setRoomId: (value) => set(() => ({ roomId: value })),

  isMapOpen: false,
  setIsMapOpen: (value) => set(() => ({ isMapOpen: value })),

  isOverviewMapOpen: false,
  setIsOverviewMapOpen: (value) => set(() => ({ isOverviewMapOpen: value })),

  // Id and type
  productObject: null,
  setProductObject: (value) => set(() => ({ productObject: value })),

  // Current product data
  productData: null,
  setProductData: (value) => set(() => ({ productData: value })),

  // Mode set by PC
  mode: null,
  setMode: (value) => set(() => ({ mode: value })),

  // Mode set by PC
  isOffline: false,
  setIsOffline: (value) => set(() => ({ isOffline: value })),
}));

export default useStore;
